import React, { useContext, useEffect, useState } from "react";
import { MainContext } from "../../context/MainContext";
import { Typography, Paper } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import * as Constants from "../../components/api/constants";
import { tr } from "date-fns/locale";

const ControlFastHeat = () => {
  const state = useContext(MainContext).state;
  const deviceId = state.selectedDevice;

  const [heatOn, setHeatOn] = useState(false);

  const RC = state.RC.split(',');

  useEffect(() => {
    if (!state.RC) return;

    const rc = state.RC.split(",");

    setHeatOn(rc[17] === "1");
  }, [state.RC]);

  const handleToggleHeat = async () => {
    try {
      const newState = !heatOn;

      sendCommand("heatNow", newState);
    } catch (err) {
      console.error(err);
      toast.error("Failed to toggle heat");
    }
  };

  const sendCommand = (command, enabled) => {
    const requestOptions = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        DeviceId: deviceId,
        Command: command,
        Value: enabled ? "On" : "Off",
      }),
      credentials: "include",
    };

    fetch(Constants.baseURL + Constants.apiSendCommand, requestOptions)
      .then((response) => {
        if (response.ok) {
          setHeatOn(enabled);

          toast.success(enabled ? "Heat Now turned ON" : "Heat Now turned OFF");

          setTimeout(() => state.refreshDeviceRF(deviceId), 8000);
          setTimeout(() => state.getUserDeviceRf(deviceId), 12000);
        } else {
          toast.error("Send failed. Please try again", {
            position: "top-right",
            autoClose: 5000,
          });
        }
      })
      .catch((error) => console.log("request failed", error));
  };

  return (
    <>
      <ToastContainer />

      <Typography
        component="h2"
        variant="h6"
        sx={{ color: "white", fontWeight: 600, mb: 1 }}
      >
        Heat Now
      </Typography>

      <Paper
        sx={{
          p: 3,
          borderRadius: 2,
          bgcolor: "rgba(255,255,255,0.05)",
          border: "1px solid rgba(255,255,255,0.08)",
          width: "100%",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: "16px",
            padding: "20px",
          }}
        >
          <Typography sx={{ color: "white", fontSize: "18px", mb: 3 }}>
            {heatOn ? "Heat Now is ON" : "Heat Now is OFF"}
          </Typography>

          <div
            onClick={handleToggleHeat}
            style={{
              position: "relative",
              width: "140px",
              height: "140px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                width: "110px",
                height: "110px",
                borderRadius: "50%",
                border: heatOn
                  ? "2px solid #ff7a18"
                  : "2px solid #2f3338",

                backgroundColor: heatOn
                  ? "rgba(255, 122, 24, 0.12)"
                  : "rgba(255, 255, 255, 0.03)",

                display: "flex",
                justifyContent: "center",
                alignItems: "center",

                transition: "all 0.25s ease",
              }}
            >
              <LocalFireDepartmentIcon
                style={{
                  fontSize: 56,
                  color: heatOn ? "#ff7a18" : "#9aa0a6",
                  transition: "all 0.25s ease",
                }}
              />
            </div>
          </div>
        </div>
      </Paper>
    </>
  );
};

export default ControlFastHeat;